/**
 * Reveals hero and section blocks inside #MainContent with a subtle fade/slide-in
 * as they enter the viewport. Only used on the home page and product pages.
 *
 * Progressive enhancement: the `.reveal-init` class (which CSS uses to hide the
 * element before it animates in) is added by this script, not present in the
 * markup — so content stays visible if JS never runs.
 */

const SELECTOR = '#MainContent .hero, #MainContent .section';

function init() {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const elements = document.querySelectorAll(SELECTOR);

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    return;
  }

  elements.forEach((element) => {
    element.classList.add('reveal-init');
  });

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0, rootMargin: '0px 0px -10% 0px' }
  );

  elements.forEach((element) => observer.observe(element));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
